
import selectOption from '@/store/dict/selectOptionDict'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { getTenantCustomTagList } from '@/api/company'
import CARDICT from '@/store/dict/carDict.js'
import {
  getCarList,
  getCarProvider,
} from '@/api/carManage'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function () {
  const oLoading = {
    fuzzy: false,
  }
  // 采购类型
  const carPurchaseTypeList = [
    {
      label: '全部',
      value: '',
    },
    ...this.dictParseList(selectOption.carPurchaseType),
  ]
  // 采购状态
  const vehiclePurchaseStatusList = [
    {
      label: '全部',
      value: '',
    },
    ...this.dictParseList(selectOption.vehiclePurchaseStatus),
  ]
  // 订单锁定状态
  const lockedStateOptions = [
    {
      label: '全部',
      value: '',
    },
    {
      label: '未锁定',
      value: '0',
    },
    {
      label: '已锁定',
      value: '1',
    },
  ]

  // 模糊搜索获取车牌号
  const getPlateNoData = async (query) => {
    query = query.trim()
    // 开启远程搜索
    if (query.length >= 4) {
      this.oLoading.fuzzySearch = true
      try {
        const { code, data } = await FuzzySearch({
          plateNo: query,
          state: 1,
        })
        if (code === 1) {
          this.$refs?.baseListManagement.setItemData({ elConfigKey: 'list', key: 'plateNo', data })
        }
        // 关闭远程搜索
        this.oLoading.fuzzySearch = false
      } catch (error) {
        this.oLoading.fuzzySearch = false
      }
    } else {
      this.$refs?.baseListManagement.setItemData({ elConfigKey: 'list', key: 'plateNo', data: [] })
    }
  }
  // 获取车辆标签
  const getCarTagList = () => {
    getTenantCustomTagList({ type: 1 }).then((res) => {
      const { data } = res
      data.unshift({
        name: '全部',
        id: '',
      })
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'tagId', data })
    })
  }
  getCarTagList()
  // 获取车源方
  const getCarProviderList = () => {
    getCarProvider({ state: 1, serviceType: 0 }).then((res) => {
      const { data } = res
      const dataList = [
        { name: '全部', id: '' },
        ...data.items,
      ]
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'providerId', data: dataList })
    })
  }
  getCarProviderList()

  const configData = {
    formData: {
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'plateNo',
          },
          elConfig: {
            filterable: true,
            remote: true,
            'reserve-keyword': true,
            loading: oLoading.fuzzy,
            placeholder: '请输入',
            'default-first-option': true,
            'remote-method': (e) => { getPlateNoData(e, 'plateNo') },
            options: {
              label: 'plateNo',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '车辆ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            clearable: true,
            placeholder: '请输入车辆ID',
          },
        },
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'select',
          itemConfig: {
            label: '运营城市',
            prop: 'adcode',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            reserveKeyword: true,
            defaultFirstOption: true,
            placeholder: '请选择',
            options: {
              label: 'city',
              value: 'adcode',
              list: [],
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '车辆创建日期',
            prop: 'carCreateTime',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '车辆标签',
            prop: 'tagId',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '采购类型',
            prop: 'purchaseType',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'label',
              value: 'value',
              list: carPurchaseTypeList,
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '采购状态',
            prop: 'purchaseState',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'label',
              value: 'value',
              list: vehiclePurchaseStatusList,
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '车源方',
            prop: 'providerId',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: 'VIN码',
            prop: 'vin',
          },
          elConfig: {
            maxlength: 18,
            clearable: true,
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '发动机号',
            prop: 'engineNo',
          },
          elConfig: {
            maxlength: 20,
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '订单锁定状态',
            prop: 'lockedState',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'label',
              value: 'value',
              list: lockedStateOptions,
            },
          },
        },
      ],
      expoprtData: {
        exportTemplate: 'CarList',
        filename: '车辆管理.xlsx',
        permissionName: 'car_vehicle_export',
      },
      dealWithSearch: this.dealWithSearch,
      customizeReset: this.customizeReset,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '车辆ID',
            width: 100,
          },
          render: ({ row }) => {
            const configObj = {
              label: 'a',
              className: 'cursor-point',
              value: row.id || '--',
              fn: () => { this.lookCarDetail(row) },
            }
            return renderContent.call(this, configObj)
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'vin',
          columnProps: {
            prop: 'vin',
            label: 'VIN码',
            width: 180,
          },

        },
        {
          name: 'city',
          columnProps: {
            prop: 'city',
            label: '运营城市',
          },
        },
        {
          name: 'brand',
          columnProps: {
            prop: 'brand',
            label: '品牌',
          },
        },
        {
          name: 'series',
          columnProps: {
            prop: 'series',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'engineNo',
          columnProps: {
            prop: 'engineNo',
            label: '发动机号',
            width: 160,
          },
        },
        {
          name: 'carState',
          columnProps: {
            prop: 'carState',
            label: '车辆状态', // 新添加的车辆状态
          },
          getText: ({ row }) => this.carStateList[row.carState],

        },
        {
          name: 'purchaseType',
          columnProps: {
            prop: 'purchaseType',
            label: '采购类型',
          },
          getText: ({ row }) => selectOption.carPurchaseType[row.purchaseType],
        },
        {
          name: 'tagList',
          columnProps: {
            prop: 'tagList',
            label: '车辆标签',
          },
          render: ({ row }) => {
            if (row && row.tagList) {
              const result = row.tagList.map((item) => {
                return this.$createElement('el-tag', { size: 'mini' }, item)
              })
              return result
            } else {
              return '--'
            }
          },
        },
        {
          name: 'lockedState',
          columnProps: {
            prop: 'lockedState',
            label: '订单',
          },
          getText: ({ row }) => {
            if (row.lockedState === 0) {
              return '未锁定'
            } else if (row.lockedState === 1) {
              return '已锁定'
            } else {
              return '--'
            }
          },
        },
        {
          name: 'inventoryTime',
          columnProps: {
            prop: 'inventoryTime',
            label: '在库时长',
          },
          getText: ({ row }) => (row.inventoryTime ? `${row.inventoryTime}天` : '--'),
        },
        {
          name: 'userName',
          columnProps: {
            prop: 'userName',
            label: '所属车管',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '车辆创建日期',
            width: 160,
          },
        },
        {
          name: 'providerName',
          columnProps: {
            prop: 'providerName',
            label: '车源方',
            width: 160,
          },
        },
        {
          name: 'purchaseState',
          columnProps: {
            prop: 'purchaseState',
            label: '采购状态',

          },
          getText: ({ row }) => selectOption.vehiclePurchaseStatus[row.purchaseState],
        },
        {
          name: 'basicItemState',
          columnProps: {
            prop: 'basicItemState',
            label: '车辆基本信息状态',
            width: 160,
          },
          render: ({ row }) => {
            // 车辆基本信息状态 1待补齐 2待提交 3待审核 4信息完整
            return CARDICT.CAR_MESSAGE()[row.basicItemState] || '--'
          },
        },
        {
          name: 'operateState',
          columnProps: {
            prop: 'operateState',
            label: '运营状态',
          },
          badgeProps: ({ row }) => { return { text: selectOption.carOperateStateDict[row.operateState], color: (row.operateState === 1 ? '#2E7EFF' : '#F5770A') } },
          type: 'badge',
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          type: 'operate',
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const optionArray = [
              // 车辆状态为待租且订单状态为未锁定的车辆展示签约提车按钮
              {
                name: 'signCar',
                label: '签约提车',
                action: () => this.signCar(row),
                permission: this.judgePermission('for_rent_sign_contract_rent_order_create') && row.carState === 20 && row.lockedState === 0,
              },
              { name: 'editCar', label: '编辑', action: () => this.editCar(row), permission: this.judgePermission('vehicle_list_edit') },
              { name: 'addInsure', label: '上保险', action: () => this.addInsure(row), permission: this.judgePermission('vehicle_list_insurance') },
              { name: 'careCar', label: '保养', action: () => this.careCar(row), permission: this.judgePermission('vehicle_maintenance_list_create') },
              { name: 'fixCar', label: '维修', action: () => this.fixCar(row), permission: this.judgePermission('vehicle_maintenance_list_create') },
              { name: 'accidentCar', label: '事故', action: () => this.accidentCar(row), permission: this.judgePermission('vehicle_accident_list_create') },
              { name: 'dealCar', label: '退出运营', action: () => this.dealCar(row), permission: this.judgePermission('vehicle_list_dispose') },
              {
                name: 'prepareCar',
                label: '备车',
                action: () => this.handlePrepareCar(row, 1),
                permission: this.judgePermission('vehicle_list_ready_lease') &&
                  ((row?.tagList?.length && !(row.tagList.includes('已备车'))) || !row.tagList.length) &&
                  [20].includes(Number(row.carState)),
              },
              {
                name: 'cancelPrepareCar',
                label: '取消备车',
                action: () => this.handlePrepareCar(row, 0),
                permission: this.judgePermission('vehicle_list_ready_lease') &&
                  row?.tagList?.length && row.tagList.includes('已备车') &&
                  [20].includes(Number(row.carState)),
              },
            ]
            return optionArray.filter((item) => item.permission) || []
          },
        },
      ],
      apiFn: getCarList,
    },
  }
  return {
    configData,
  }
}
// 渲染函数
function renderContent(configObj = { label: 'span', value: '', className: '' }) {
  return this.$createElement(configObj.label, {
    class: configObj.className,
    on: {
      click: configObj.fn || '',
    },
  }, configObj.value)
}
